module.exports = {
  accountManager: 'Account Management',
  accountType: 'Account Type',
  mobileValid: 'Mobile Verification',
  setPhoneFirst: 'Please enter your mobile number first',
  phoneValid: 'Mobile Verification',
  resetPassword: 'Reset Password',
  passwordInconsistent: 'Reset Successfully, Please Re-login',
  pwdEditTips: 'Your account or password had been changed, please re-login. If this is not your operation, please contact customer service',
  change: 'Change',
  editPassword: 'Change Password',
  merchantAccount: 'Merchant account',
  belongMerchant: 'Affiliated Merchant',
  merchantPassword: 'Merchant Account',
  email: 'Mail',
  storeLoginPhone: 'Store Login Phone',
  userName: 'Username',
  currentPassword: 'Current Password',
  newLoginPassword: 'New login password',
  editSuccess3s: 'Change login mobile successfully, 3 s',
  reLogin: 're-login',
  complete: 'complete',
  changePhoneMustNeedValid: 'Please choose verification mode to change login mobile',
  phoneNumberValid: 'Mobile Verification',
  idValid: 'Identity Information Verification',
  realName: 'Name',
  credentialsType: 'Certificates Type',
  credentialsNumber: 'Certificates Number',
  changeLoginPhone: 'Change Login Mobile',
  validIsCurrentLoginPhone: 'The entered mobile phone number is inconsistent with the current login account',
  passwordCouldNotIncludeSpace: 'Password could\'t  include space'
}
